(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.ftabsInit === '1') return;
    root.dataset.ftabsInit = '1';

    var tabs = root.querySelectorAll('.ftabs__tab');
    var panels = root.querySelectorAll('.ftabs__panel');
    var prevBtn = root.querySelector('[data-ftabs-prev]');
    var nextBtn = root.querySelector('[data-ftabs-next]');

    function activate(index) {
      tabs.forEach(function (t) {
        var on = String(t.dataset.tabIndex) === String(index);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = String(p.dataset.tabPanel) === String(index);
        p.classList.toggle('is-active', on);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.tabIndex);
      });
    });

    function activeTrack() {
      var panel = root.querySelector('.ftabs__panel.is-active');
      return panel ? panel.querySelector('[data-ftabs-track]') : null;
    }

    function scrollByCard(direction) {
      var track = activeTrack();
      if (!track) return;
      var card = track.querySelector('.ftabs__card');
      var step = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    // Hide the arrows when the active track has nothing to scroll (the cards
    // already fit inside the viewport). 1px tolerance avoids sub-pixel jitter.
    function updateArrows() {
      var track = activeTrack();
      var scrollable = !!track && track.scrollWidth - track.clientWidth > 1;
      root.classList.toggle('ftabs--no-overflow', !scrollable);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    // Re-evaluate overflow whenever the layout that affects it can change:
    // tab switches, viewport resize, and image loads (card widths settle only
    // once product images have dimensions). The tab listener below fires after
    // the activate() click handler bound earlier, so the new panel is active.
    tabs.forEach(function (tab) {
      tab.addEventListener('click', updateArrows);
    });

    // Mobile compact switcher: the select proxies to the tab buttons so the
    // exact same activate/arrow logic runs; pill clicks keep it in sync.
    var select = root.querySelector('[data-ftabs-select]');
    if (select) {
      select.addEventListener('change', function () {
        var btn = root.querySelector('.ftabs__tab[data-tab-index="' + select.value + '"]');
        if (btn) {
          btn.click();
        } else {
          activate(select.value);
          updateArrows();
        }
      });
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          select.value = tab.dataset.tabIndex;
        });
      });
    }

    window.addEventListener('resize', updateArrows);
    root.querySelectorAll('.ftabs__card img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', updateArrows, { once: true });
    });
    updateArrows();
  }

  function bootAll() {
    document.querySelectorAll('[data-ftabs-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // Re-run on Shopify section-load events (theme editor + hot reload)
  document.addEventListener('shopify:section:load', bootAll);
})();
